/**
 * Created by richardlovejoy on 2/27/17.
 */
/////////////////////////////////////////////////////////////////////////
// CONSTRUCTOR //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const CupSparkle = function(game) {

  Phaser.Group.call(this, game);

  // visual
  this.emitter = null;
  this.visible = false;


  this.init();
};

/////////////////////////////////////////////////////////////////////////
// CONSTANTS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
CupSparkle.PARTICLE_DATA_ADDED = false;

/////////////////////////////////////////////////////////////////////////
// MEMBERS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
CupSparkle.prototype = Object.assign( Object.create( Phaser.Group.prototype ), {

  constructor: CupSparkle,

  /**
   *
   */
  init: function() {

    // create emitter
    var manager = this.game.display.particleStorm;
    if (!CupSparkle.PARTICLE_DATA_ADDED) {
      var mediumAward = {
        image: 'skee',
        frame: 'efxSparkle1.png',
        blendMode: 'NORMAL',
        lifespan: { min: 500, max: 700 },
        scale: { min: 0.9, max: 1.3 },
        vx: {min: -2, max: 2},
        vy: {min: -6, max: -4},
        delay: {min: 0, max: 200},
        rotation: {value: {min: 0, max: 90}, delta: {min: -2, max: 2}},
        alpha: { value: 1, control : [ { x: 0, y: 1 }, { x: 0.3, y: 1 }, { x: 1, y: 0 } ] },
        red: {min: 240, max: 255},
        green: {min: 240, max: 255},
        blue: {min: 240, max: 255}
      };
      var largeAward = {
        image: 'skee',
        frame: 'starParticle.png',
        blendMode: 'ADD',
        lifespan: { min: 800, max: 1000 },
        scale: { min: 0.3, max: 0.5 },
        vy: {min: -6.5, max: -4.5},
        delay: {min: 200, max: 300},
        rotation: {value: {min: 0, max: 90}, delta: {min: -3, max: 3}},
        alpha: { value: 1, control : [ { x: 0, y: 0 }, { x: 0.3, y: 1 }, { x: 1, y: 0 } ] }
        //red: {min: 200, max: 255, control: [{x: 0, y: 0}, {x: 1, y:1}]},
        //green: {min: 200, max: 255, control: [{x: 0, y: 0}, {x: 1, y:1}]},
        //blue: {min: 200, max: 255, control: [{x: 0, y: 0}, {x: 1, y:1}]}

      };
      var largeAwardLeft_brown = Object.assign({
        vx: {min: -4, max: -2, control : [ { x: 0, y: 0.3 }, { x: 0.6, y: 1 }, { x: 1, y: 0.2 } ]}
      }, largeAward);
      var largeAwardRight_brown = Object.assign({
        vx: {min: 2, max: 4, control : [ { x: 0, y: 0.3 }, { x: 0.6, y: 1 }, { x: 1, y: 0.2 } ]}
      }, largeAward);
      var largeAwardLeft_red = Object.assign({
        red: {min: 200, max: 255, control: [{x: 0, y: 0.5}, {x: 0.5, y:1}]},
      }, largeAwardLeft_brown);
      var largeAwardRight_red = Object.assign({
        red: {min: 200, max: 255, control: [{x: 0, y: 0.5}, {x: 0.5, y:1}]},
      }, largeAwardRight_brown);
      var largeAwardLeft_blue = Object.assign({
        green: {min: 200, max: 255, control: [{x: 0, y: 0.5}, {x: 0.5, y:1}]},
        blue: {min: 200, max: 255, control: [{x: 0, y: 0.5}, {x: 0.5, y:1}]}
      }, largeAwardLeft_brown);
      var largeAwardRight_blue = Object.assign({
        green: {min: 200, max: 255, control: [{x: 0, y: 0.5}, {x: 0.5, y:1}]},
        blue: {min: 200, max: 255, control: [{x: 0, y: 0.5}, {x: 0.5, y:1}]},
      }, largeAwardRight_brown);

      manager.addData('mediumAward', mediumAward);
      manager.addData('largeAwardLeft_brown', largeAwardLeft_brown);
      manager.addData('largeAwardRight_brown', largeAwardRight_brown);
      manager.addData('largeAwardLeft_red', largeAwardLeft_red);
      manager.addData('largeAwardRight_red', largeAwardRight_red);
      manager.addData('largeAwardLeft_blue', largeAwardLeft_blue);
      manager.addData('largeAwardRight_blue', largeAwardRight_blue);

      CupSparkle.PARTICLE_DATA_ADDED = true;
    }

    this.emitter = manager.createEmitter();
    this.emitter.force = {x: 0, y: 0.18};  // gravity
    this.emitter.seed(30);
    this.emitter.addToWorld(this);
    this.emitter.enabled = false;

  }, // end Init

  reset: function() {


  },

  run: function(award, topParent) {


    // forget stop timeout
    if (this.stopper) {
      clearTimeout(this.stopper);
    }

    this.visible = true;

    this.emitter.enabled = true;
    if (award.level > 1) {
      this.emitter.emit('largeAwardLeft_'+award.ballAttributes.color, 0, 0, {total: 4});
      this.emitter.emit('largeAwardRight_'+award.ballAttributes.color, 0, 0, {total: 4});
    }
    this.emitter.emit('mediumAward', 0, 0, {total: 30});

    // add to topParent after a delay
    setTimeout(() => {
      topParent.add(this);
    }, 500);

    // self-stop (enabled emitters are always processed)
    this.stopper = setTimeout(this.stop.bind(this), 3000);
  },

  stop: function() {

    this.visible = false;
    this.emitter.enabled = false;
    this.stopper = null;

  },

  repeat: function(x, y) {

    //this.emitter.emit('shimmerInner', x, y, {total: 16, repeat: -1, frequency: 1000});
    //this.emitter.emit('shimmerOuter', x, y, {total: 20, repeat: -1, frequency: 1000});

  }

});

export default CupSparkle;





// WEBPACK FOOTER //
// ./app/src/display/effects/CupSparkle.js